import { GenericValidationMessages, Space, TradeApprove } from '../../../../../components/core-v2'
import TradeApproveReadonly from '../../../../../components/core-v2/molecules/trade-approve-readonly'
import TradeEventDisplay from '../../../../../components/core-v2/organisms/trade-event-display/trade-event-display'
import { accountStepToDisplayName } from '../../../../../types/tradeApproval'
import { TradeActivationStep } from '../../../../tradebuilder-v2/types'
import { TradeActivateStepState } from '../state/trade-activate-slice'

export type TradeActivateStatelessProps = {
  onTradeActivate: (comment: string) => void
  state: TradeActivateStepState
  status: TradeActivationStep
}

const TradeActivateStateless = ({
  onTradeActivate,
  state,
  status
}: TradeActivateStatelessProps) => {
  const isEditable =
    state.userType === 'admin' || (state.userType === 'absa' && state.userRoles.includes('Trading'))

  const onTradeApprove = comments => {
    onTradeActivate(comments)
  }

  const errorsList = []
  for (const errorName in state.errors) {
    errorsList.push(state.errors[errorName])
  }

  const renderCompletedState = () =>
    state.approvalEvents?.reduce(
      (acc, approvalEvent) =>
        approvalEvent.statusAfter === accountStepToDisplayName(status)
          ? [...acc, <TradeEventDisplay key={approvalEvent.userId} {...approvalEvent} />]
          : acc,
      []
    )

  const renderPendingState = () => (
    <>
      <TradeApprove
        allowComments
        approveBtnCaption="Activate"
        approvingSection="trade"
        canApprove={state.canProceed}
        userName={state.userName}
        onApprove={onTradeApprove}
      />
      <Space mt={5}>
        <GenericValidationMessages errorMessages={errorsList} />
      </Space>
    </>
  )

  const renderReadonlyState = () => (
    <Space my={6}>
      <TradeApproveReadonly waitingDescription="This trade is awaiting activation. Please check back later" />
    </Space>
  )

  return (
    <>
      {state.hasCompleted && renderCompletedState().slice(-1)[0]}
      {!state.hasCompleted && isEditable && renderPendingState()}
      {!state.hasCompleted && !isEditable && renderReadonlyState()}
    </>
  )
}

export default TradeActivateStateless
